import { Controller } from "@hotwired/stimulus"
import { isAValue } from "web/services/helpers"

export default class ElementValuesController extends Controller {
  static targets = ["input"]

  setValues(event) {
    const formValuesByInputName =
      event.params.formValuesByInputName || event.detail?.value?.values
    const triggerChangeEvent =
      event.params.triggerChangeEvent ||
      event.detail?.value?.trigger_change_event

    this.setFormValues(formValuesByInputName, triggerChangeEvent)
  }

  setFormValues(formValuesByInputName = {}, triggerChangeEvent = false) {
    this.inputTargets.forEach((element) => {
      const key = element.dataset.elementValuesKey || element.name

      if (
        key in formValuesByInputName &&
        isAValue(formValuesByInputName[key])
      ) {
        element.value = formValuesByInputName[key]

        if (triggerChangeEvent) {
          element.dispatchEvent(new Event("change"))
        }
      }
    })
  }
}
